/* eslint-disable react/destructuring-assignment */
import { withAuth } from '@okta/okta-react';

const LogoutHandler = ({ auth }) => {
  auth.logout('/');
  return null;
};

export default withAuth(LogoutHandler);
